
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/8afb2a5de69c924b4acd588d4e3deb2e/2263835a614b904a2284171294cf6050.png" 
              alt="Cofunnels"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Done-for-you funnels that convert. Helping businesses generate millions in revenue through high-converting sales funnels.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300 cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300 cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300 cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">ClickFunnels Development</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">GoHighLevel Funnels</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Lead Generation</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">E-commerce Funnels</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Webinar Funnels</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Conversion Optimization</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              <li><a href="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#testimonials" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Success Stories</a></li>
              <li><a href="/pricing" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Pricing</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              <li><a href="https://fiverr.com/cofunnels" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Fiverr Profile</a></li>
              <li><a href="/blog" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Blog</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-phone-line mt-1 mr-3"></i>
                <div>
                  <p className="text-gray-400">Call our agents 24/7</p>
                  <a href="tel:+17372527530" className="text-white hover:text-blue-400 transition-colors cursor-pointer">
                    +1 (737) 252-7530
                  </a>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-mail-line mt-1 mr-3"></i>
                <div>
                  <p className="text-gray-400">Email Us</p>
                  <a href="mailto:hello@cofunnels.com" className="text-white hover:text-blue-400 transition-colors">hello@cofunnels.com</a>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-time-line mt-1 mr-3"></i>
                <div>
                  <p className="text-gray-400">Response Time</p>
                  <p className="text-white">Within 24 hours</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-customer-service-2-line mt-1 mr-3"></i>
                <div>
                  <p className="text-gray-400">Support</p>
                  <p className="text-white">24/7 Available</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 Cofunnels. All rights reserved.
            </div>
            <div className="flex flex-wrap items-center space-x-6 text-sm">
              <a href="/privacy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="/terms" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Terms of Service</a>
              <a href="/cookies" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Cookie Policy</a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Made with Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
